function getCookieFS(name) {
    try {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match !== null && match.length === 3) {
            return match[2];
        } else {
            return null;
        }
    } catch (err) {
        console.warn("FS: unexpected exception in getcookie : " + err);
        return null;
    }
}

if (getCookieFS('FSreal') !== null) {
    // FS code start
    window['_fs_debug'] = false;
    window['_fs_host'] = 'fullstory.com';
    window['_fs_org'] = 'HZB6B';
    window['_fs_namespace'] = 'FS';
    (function (m, n, e, t, l, o, g, y) {
        if (e in m) {
            if (m.console && m.console.log) {
                m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
            }
            return;
        }
        g = m[e] = function (a, b, s) {
            g.q ? g.q.push([a, b, s]) : g._api(a, b, s);
        };
        g.q = [];
        o = n.createElement(t);
        o.async = 1;
        o.src = 'https://edge.' + _fs_host + '/s/fs.js';
        y = n.getElementsByTagName(t)[0];
        y.parentNode.insertBefore(o, y);
        g.identify = function (i, v, s) {
            g(l, {uid: i}, s);
            if (v) g(l, v, s)
        };
        g.setUserVars = function (v, s) {
            g(l, v, s)
        };
        g.event = function (i, v, s) {
            g('event', {n: i, p: v}, s)
        };
        g.shutdown = function () {
            g("rec", !1)
        };
        g.restart = function () {
            g("rec", !0)
        };
        g.consent = function (a) {
            g("consent", !arguments.length || a)
        };
        g.identifyAccount = function (i, v) {
            o = 'account';
            v = v || {};
            v.acctId = i;
            g(o, v)
        };
        g.clearUserCookie = function () {
        };
    })(window, document, window['_fs_namespace'], 'script', 'user');
    // FS code end
}